// Batch C (AB#2195) — shared helpers for the Super Admin booking views.

import { useLanguage } from '../../../contexts/LanguageContext';

/** Bookings support can still cancel: Pending or Confirmed (wire name "Approved"). */
export function isOpenBooking(status: string): boolean {
    return status === 'Pending' || status === 'Booked' || status === 'Approved';
}

/** Map the wire status enum NAME to a localized label (existing support terms). */
export function useBookingStatusLabel() {
    const { t } = useLanguage();
    return (status: string): string => {
        switch (status) {
            case 'Pending':
            case 'Booked':
                return t('superadmin.bookings.status.booked');
            case 'Approved':
                return t('superadmin.bookings.status.approved');
            case 'Completed':
                return t('superadmin.bookings.status.completed');
            case 'Cancelled':
                return t('superadmin.bookings.status.cancelled');
            case 'NoShow':
                return t('superadmin.bookings.status.noshow');
            case 'Arrived':
                return t('superadmin.bookings.status.arrived');
            case 'Started':
                return t('superadmin.bookings.status.started');
            default:
                return status || '—';
        }
    };
}
